import React, { PureComponent } from 'react';
import { TextField } from '@mui/material';
import DialogWrapper from '../../../../common/components/DialogWrapper/DialogWrapper';

class CreationDialog extends PureComponent {
  render() {
    return (
      <DialogWrapper
        onClickCancel={this.props.onClickCancel}
        onClickMainAction={this.props.onClickMainAction}
        open={this.props.open}
        title={this.props.title}
        disableMainAction={this.props.disableMainAction}
      >
        <TextField
          variant="standard"
          data-qa="qa-edit"
          label={this.props.textfieldName}
          error={this.props.errorText !== ''}
          helperText={this.props.errorText}
          style={{ width: '100%' }}
          onChange={(event) =>
            this.props.onChangeCallback(this.props.propertyToEdit, event.target.value)
          }
          margin="normal"
        />
      </DialogWrapper>
    );
  }
}

export default CreationDialog;
